<template>
  <el-select :value="myValue" class="statisticalTypeSelect" style="width: 100%" v-bind="$attrs" v-on="$listeners">
    <el-option v-for="(item,index) in items" :key="index" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
import SetDefaultValue from "@/mixins/SetDefaultValue";

export default {
  inheritAttrs: false,
  name: "statisticalTypeSelect",
  mixins: [SetDefaultValue],
  async beforeMount() {
    console.log(this.hasSchool)
    this.items = [];
    if (this.hasSchool) {
      this.items.push({'label': '按学校统计', "value": "$school"})
    }
    this.items.push({'label': '按年龄统计', "value": "$age"});
    this.items.push({'label': '按年级统计', "value": "$grade"});
    this.items.push({'label': '按性别统计', "value": "$sex"});
    this.setDefaultValue("$age")
  },

  data() {
    return {
      items: [],

    }
  },
  props: {
    hasSchool: undefined,
    value: {}
  },
  computed: {
    myValue() {
      return this.value
    }
  },

  // watch:{
  //   myValue:{
  //     deep:true,
  //     handler(n){
  //       if(n){
  //         this.$emit('updateValue')
  //       }
  //     }
  //   }
  //
  // }

}
</script>

<style scoped>

</style>
